import React, { Component } from 'react';
import { Row } from 'reactstrap';
import * as AiIcons from 'react-icons/ai';
import {  appTouchStartListener,  appTouchEndListener, appImageZoomUnsubscribe } from '../../components/ImageZoomUtils.js';
import { imageGaleryScrollProcessor, isPageScrollable, scrollToStroredPosition } from '../../components/ScrollUtils.js';
import { isBrowsingMode } from '../../components/Utils.js';
import Const from '../Const';
import  { renderVideoPlayerWrapperG, renderVideoPlayerWrapperGB, getMatchingMediaDevice } from '../../utils/VideoPlayerUtils.js';
import { setGaleryCellWidth } from '../../utils/CssUtils';
import { isShowThumbNails, unloadVideoFromDiv, getVideoConfig } from '../../utils/VideoUtils';

class GetImages extends Component {
    constructor(props){
        super(props);
        this.state = {            
            userImage : null,
            userClickedPost : null,
            isOpen: false,
            galleryClass: '',
            galeryStyleObj : {},
        };
        this.onTouchStartHandler = this.onTouchStartHandler.bind(this);
		this.onTouchendHandler = this.onTouchEndtHandler.bind(this);
		this.pinchToZoom = null;
        this.dialogIsClosed = false; // to make sure setting state is not done multiple times
        setGaleryCellWidth(); // more presized setting than from session utils
    }

    componentDidMount() {
        const { anyUser, parent }  = this.props;

        if (!anyUser.isFinalPage && !isPageScrollable()) {
            // gaerfy is not covering the screen, so 3-dots are exposed in the middle
            // to fix it:
            parent.setState({ showLoadingImageForGallery : false });
        }
        scrollToStroredPosition(parent);
    }

    setUserPostForGaleryCell = (userClickedPost, userPicture, userName) => {
        this.unloadLargeVideo();
        this.dialogIsClosed = false;
        this.setState({
                        isOpen: !this.state.isOpen,
                        userClickedPost : userClickedPost,
                        userPicture: userPicture,
                        userClickedPostLikesCount: userClickedPost.likesCount,
                        userName: userName,
                        galleryClass: this.getGaleryLargeCellClass(userClickedPost),
                        galeryStyleObj: this.getGaleryLargeStyleObj(userClickedPost), // this removes flicker effect
                     });
    }

    closeShowDialog = () => {
        if (!this.dialogIsClosed) {
            this.unloadLargeVideo();
            this.setState({ isOpen: !this.state.isOpen });
            this.dialogIsClosed = true;
        }
    };

    unloadLargeVideo() {
        let largeVideoDiv = document.getElementById('largeVideo');

        if (this.state.isOpen && largeVideoDiv) {
            unloadVideoFromDiv(largeVideoDiv);
        }
    }

    onTouchStartHandler(e) {
		appTouchStartListener(e, this);
	}

	onTouchEndtHandler(e) {
		appTouchEndListener(e);
	}

    componentWillUnmount() {
        let galeryDiv = document.getElementById('galery');
		if (this) {
			appImageZoomUnsubscribe(this);
		}
        imageGaleryScrollProcessor(false);
        galeryDiv.removeEventListener('click', this.clickHandler);
	}

    showLikes(userPost, anyUser) {
        if (isBrowsingMode(anyUser)) {
            return null;
        }
        else{
            return (
                <div className="overlay">
                    <div className="text">
                        <AiIcons.AiOutlineHeart className="" />
                        { userPost.likesCount}
                    </div>
                </div> 
            )
        }
    }

    getGaleryLargeCellClass(userClickedPost) {
        let galeryCellClass = "";

        if (userClickedPost.hasOwnProperty('postVideo')) {
            if (userClickedPost.imgHeight < userClickedPost.imgWidth) {
                galeryCellClass = 'galary-video-large galary-video-large-center';
            }
            else {
                galeryCellClass = 'galary-video-large';
            }
        }
        
        return galeryCellClass;
    }

    getGaleryLargeStyleObj(userClickedPost) {
        let galeryStyleObj = {};
        let galeryDiv;
        let koef;

        if (userClickedPost.hasOwnProperty('postVideo')) {
            if (userClickedPost.imgHeight > userClickedPost.imgWidth) {
                // portrait video
                koef = userClickedPost.imgWidth / userClickedPost.imgHeight;
                galeryDiv= document.getElementById('galery');
                galeryStyleObj = {width: koef * galeryDiv.clientWidth +'px', justifyContent: 'center'};
            }
            // else if (isMacDesktop()) {
            else {
                // prevents empty div on the screen before video appears on Mac
                koef = userClickedPost.imgHeight / userClickedPost.imgWidth;
                galeryDiv= document.getElementById('galery');
                galeryStyleObj = {width: koef * galeryDiv.clientWidth +'px', justifyContent: 'center'};
            }
        }
        galeryStyleObj = {};
        
        return galeryStyleObj;
    }

    render() {
        const { anyUser }  = this.props;
        const { userPicture, userName, userPosts } = anyUser;
        const { isOpen, userClickedPost, galleryClass, galeryStyleObj } = this.state;
        const filterUserPosts = userPosts.filter(post => post.postImg || post.postVideo);
        const mediaDeviceObj = getMatchingMediaDevice();
        const galeryCellClassHeight = mediaDeviceObj.width;
        const videoPlayingAtStart = (mediaDeviceObj.mediaDevice === Const.PHONE_MEDIA_DEVICE) ? true : false;
        const videoIsMutedAtStart = (mediaDeviceObj.mediaDevice === Const.PHONE_MEDIA_DEVICE) ? true : false;
        const fullOverlayStyle = {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 10,
        };
        //
        imageGaleryScrollProcessor(isOpen);
        if (!anyUser) {
            return null;
        }
        return(
            <>              
                <div id='galery' className="after-app-wrap-images-div" >
                    {
                      isOpen && userClickedPost.hasOwnProperty('postImg') &&
                      
                        <dialog 
                            className="dialog pointer-view"
                            open
                            onClick={this.closeShowDialog}
                            onTouchStart={this.onTouchStartHandler} 
                            onTouchEnd={this.onTouchEndtHandler}
                        >
                            <img className="" alt={ Const.POST_IMAGE_ALT } src={ userClickedPost.postImg }></img>
                        </dialog>
                    }  

                    {
                      isOpen && userClickedPost.hasOwnProperty('postVideo') &&
                      <div>
                            <dialog style = { galeryStyleObj }
                                className={`dialog pointer-view ${galleryClass}`}
                                open
                                onClick={this.closeShowDialog}
                                onTouchStart={this.onTouchStartHandler} 
                                onTouchEnd={this.onTouchEndtHandler}
                            >
                                <div id="largeVideo"className="">
                                    { renderVideoPlayerWrapperGB(userClickedPost, true, true, false, getVideoConfig(userClickedPost, null)) }
                                </div>
                            </dialog>
                            <div style={ fullOverlayStyle } onClick={ this.closeShowDialog } 
                                 // to be able to close large video by clicking 
                                 // outside of the video - crtytical in some portrait phone use cases  
                            />
                        </div>
                    }                            

                    <Row className="profile-posts-and-channels" style={{Background: 'tranparent'}}>
                        <div className="library-div-profile" >
                            {  
                               filterUserPosts.map((userPost) => 
                                <div  key={ userPost.postId } className="image-text-div" >                                 
                                        {
                                            userPost.hasOwnProperty('postImg') &&
                                            <button className="square-button" onClick={() => {
                                                    this.setUserPostForGaleryCell(userPost, userPicture, userName)
                                                }}>
                                                <img style={{height: galeryCellClassHeight + 'px', width: galeryCellClassHeight + 'px'}} className="img-fluid image" alt={Const.GALERY_IMAGE_ALT} src= { userPost.postImg } />
                                                { this.showLikes(userPost, anyUser) }
                                            </button>
                                            
                                        }    

                                        {
                                             userPost.hasOwnProperty('postVideo')  && isShowThumbNails() &&
                                            <button className="square-button" onClick={() => {
                                                this.setUserPostForGaleryCell(userPost, userPicture, userName);
                                            }}>
                                                <div className="video-thumbnail-container">
                                                    <img 
                                                        style={{ height: `${galeryCellClassHeight}px`, width: `${galeryCellClassHeight}px` }} 
                                                        className="img-fluid image" 
                                                        alt={Const.GALERY_IMAGE_ALT} 
                                                        src={userPost.thumbnail} 
                                                    />
                                                    {/* 🎥 🎞️ 📹 */}
                                                    <div className="video-icon">🎬</div>
                                                </div>
                                                {this.showLikes(userPost, anyUser)}
                                            </button>
                                        }

                                        {
                                             userPost.hasOwnProperty('postVideo') && !isShowThumbNails() &&
                                             <button className="square-button"> 
                                                 <div  className="galary-video-small" >
                                                       { renderVideoPlayerWrapperG(userPost, videoPlayingAtStart, true, videoIsMutedAtStart) }
                                                 </div>
                                             </button>
                                        }                 
                                </div>  
                            )} 
                        </div>
                    </Row> 
                </div>
            </>
        );
    }
}
  
export default GetImages;
